/**
 * Tres Commas flow mutations — the Voluum-shaped flow writes at
 * /tres-commas/flows (the backend refuses any flow outside its write
 * allow-list with a 403 that names the reason).
 * For Media Devoted | Created By Ciro Autiero
 */

import {
  useFlowItemWeights,
  useFlowPathToggle,
  useFlowPathWeights,
  type FlowMutationTarget,
} from '@/hooks/voluum/voluum-shape-flow-mutations';

import { tresCommasKeys } from './keys';

const TRES_COMMAS_FLOWS: FlowMutationTarget = {
  base: '/tres-commas/flows',
  flowKey: (flowId) => tresCommasKeys.flow(flowId),
};

export function useTresCommasToggleFlowPathStatus() {
  return useFlowPathToggle(TRES_COMMAS_FLOWS);
}

export function useTresCommasUpdateFlowItemWeights() {
  return useFlowItemWeights(TRES_COMMAS_FLOWS);
}

export function useTresCommasUpdateFlowPathWeights() {
  return useFlowPathWeights(TRES_COMMAS_FLOWS);
}
